import { Component, OnInit, Input } from '@angular/core';
import { AuditService } from 'app/audit/services/audit.service';
import { Result } from 'app/core/models/result';
import { ModuleAuditListModel } from 'app/module/models/module-audit-list.model';
import { ModuleService } from 'app/module/services/module.service';

@Component({
    selector: 'app-module-audit-list',
    templateUrl: './module-audit-list.component.html',
    styleUrls: ['./module-audit-list.component.css']
})
export class ModuleAuditListComponent implements OnInit {
    @Input() moduleId: string;
    @Input() isEditMode: boolean = false;
    selectedAuditId: string;
    errors: string[];
    moduleAudits: ModuleAuditListModel[];

    constructor(
        private moduleService: ModuleService,
        private auditService: AuditService
    ) { }

    ngOnInit() {
        this.load();
    }

    load(): void {
        this.moduleService.getModuleAudits(this.moduleId).subscribe(
            moduleAudits => {
                this.moduleAudits = moduleAudits;
            },
            error => this.errors = error.errorList
        );
    }

    onModuleAuditAdded($event): void {
        this.load();
    }

    deleteModuleAudits(): void {
        this.auditService.deleteAuditModule(this.selectedAuditId, this.moduleId).subscribe(
            result => this.load(),
            error => this.errors = (<Result>error).errorList
        );
    }
}
